"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePropertiesDestinationCore = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../../base-utils/map-creator");
var table_properties_1 = require("../../../../../../core/model/tables/properties/table-properties");
var table_borders_destination_1 = require("../../../borders/table-borders-destination");
var width_unit_destination_1 = require("../../width-unit-destination");
var table_alignment_destination_1 = require("./table-alignment-destination");
var table_avoid_double_borders_destination_1 = require("./table-avoid-double-borders-destination");
var table_cell_margins_destination_1 = require("./table-cell-margins-destination");
var table_layout_destination_1 = require("./table-layout-destination");
var table_look_destination_1 = require("./table-look-destination");
var table_overlap_destination_1 = require("./table-overlap-destination");
var table_properties_base_destination_1 = require("./table-properties-base-destination");
var table_right_to_left_destination_1 = require("./table-right-to-left-destination");
var table_style_col_band_size_destination_1 = require("./table-style-col-band-size-destination");
var table_style_row_band_size_destination_1 = require("./table-style-row-band-size-destination");
var table_style_shading_destination_1 = require("./table-style-shading-destination");
var TablePropertiesDestinationCore = (function (_super) {
    tslib_1.__extends(TablePropertiesDestinationCore, _super);
    function TablePropertiesDestinationCore(data, table, tableProperties) {
        var _this = _super.call(this, data, tableProperties) || this;
        _this.table = table;
        _this.tableProperties = tableProperties;
        return _this;
    }
    Object.defineProperty(TablePropertiesDestinationCore.prototype, "elementHandlerTable", {
        get: function () {
            return TablePropertiesDestinationCore.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    TablePropertiesDestinationCore.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    TablePropertiesDestinationCore.getProperties = function (data) {
        return TablePropertiesDestinationCore.getThis(data).tableProperties;
    };
    TablePropertiesDestinationCore.handlerTable = new map_creator_1.MapCreator()
        .add('tblW', function (data) {
        return new width_unit_destination_1.WidthUnitNonNegativeDestination(data, TablePropertiesDestinationCore.getThis(data).table.preferredWidth, function () { });
    })
        .add('tblpPr', function (_data) {
        return null;
    })
        .add('tblInd', function (data) {
        var props = TablePropertiesDestinationCore.getProperties(data);
        return new width_unit_destination_1.WidthUnitDestination(data, props.indent, function () {
            props.setUseValue(table_properties_1.TablePropertiesMask.UseTableIndent, true);
        });
    })
        .add('tblLook', function (data) {
        return new table_look_destination_1.TableLookDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data));
    })
        .add('tblBorders', function (data) { return new table_borders_destination_1.TableBordersDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getThis(data).properties); })
        .add('tblCellMar', function (data) { return new table_cell_margins_destination_1.TableCellMarginsDestination(data, TablePropertiesDestinationCore.getProperties(data), {
        top: table_properties_1.TablePropertyDescriptor.topMargin,
        right: table_properties_1.TablePropertyDescriptor.rightMargin,
        bottom: table_properties_1.TablePropertyDescriptor.bottomMargin,
        left: table_properties_1.TablePropertyDescriptor.leftMargin
    }); })
        .add('tblCellSpacing', function (data) {
        var props = TablePropertiesDestinationCore.getProperties(data);
        return new width_unit_destination_1.WidthUnitNonNegativeDestination(data, props.cellSpacing, function () { return props.setUseValue(table_properties_1.TablePropertiesMask.UseCellSpacing, true); });
    })
        .add('tblLayout', function (data) { return new table_layout_destination_1.TableLayoutDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .add('tblOverlap', function (data) { return new table_overlap_destination_1.TableOverlapDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .add('tblStyleColBandSize', function (data) { return new table_style_col_band_size_destination_1.TableStyleColBandSizeDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .add('tblStyleRowBandSize', function (data) { return new table_style_row_band_size_destination_1.TableStyleRowBandSizeDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .add('shd', function (data) { return new table_style_shading_destination_1.TableStyleShadingDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .add('jc', function (data) { return new table_alignment_destination_1.TableAlignmentDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .add('adb', function (data) { return new table_avoid_double_borders_destination_1.TableAvoidDoubleBordersDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .add('bidiVisual', function (data) { return new table_right_to_left_destination_1.TableRightToLeftDestination(data, TablePropertiesDestinationCore.getThis(data).table, TablePropertiesDestinationCore.getProperties(data)); })
        .get();
    return TablePropertiesDestinationCore;
}(table_properties_base_destination_1.TablePropertiesBaseDestination));
exports.TablePropertiesDestinationCore = TablePropertiesDestinationCore;
